import { useEffect } from 'react';

import { Logger } from '@farmersdog/logger';

import { useGetLead } from '../../graphql/queries/useGetLead';

interface useCheckVetRecipesAvailabilityArgs {
  vetRecipeNames: string[];
  availableRecipeNames: string[];
}

export const useCheckVetRecipesAvailability = ({
  vetRecipeNames,
  availableRecipeNames,
}: useCheckVetRecipesAvailabilityArgs): void => {
  const { data } = useGetLead();
  const leadEmail = data?.lead?.email;

  useEffect(() => {
    if (vetRecipeNames.length > 0 && leadEmail) {
      const unavailableRecipes = vetRecipeNames.filter(
        recipe => !availableRecipeNames.includes(recipe)
      );

      if (unavailableRecipes.length > 0) {
        const logger = new Logger(
          'tosa:frontend:vet:checkVetPlanAndAvailableRecipes'
        );

        logger.error('Vet plan recipe not found in available recipes', {
          vetRecipeNames,
          availableRecipeNames,
          leadEmail,
        });
      }
    }
  }, [vetRecipeNames, availableRecipeNames, leadEmail]);
};
